import {
  FilterMode,
  CurrencyCreateMutationVariables,
  Currency_OrderBy,
  Currency,
  SortOrder,
  Currency_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const currencyService = {
  createOne: buildCreateOne(
    (currencyCreateVariables: CurrencyCreateMutationVariables) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.currencyCreate(currencyCreateVariables);
        return result.currencyCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.currencyOne({ id });
    return result.currencyOne as Currency;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: Currency_OrderBy[] | null = null,
    filter: Currency_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: Currency_Filter | undefined;
    if (searchValue !== "") {
      where = {
        OR: [
          { code: { contains: searchValue, mode: FilterMode.Insensitive } },
          { name: { contains: searchValue, mode: FilterMode.Insensitive } },
        ],
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.currencyListWithOffset({
      offset,
      take,
      orderBy: orderBy
        ? orderBy
        : [{ code: SortOrder.Asc }, { name: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.currencyListWithOffset
    ) as Currency[];
    return { list, orderBy };
  },
};
